export const ru_messagesdata = {
  loading: "Загрузка",
  error: "Ошибка",
  error404: "Страница не найдена",
};
